import { useQuery } from "@tanstack/react-query";
import { ISalesPersonInfo } from "../declarations";
import { createApiClient } from "../utilities/apiClient";

const getSailInfoSalesPerson = async (
    guid: string,
): Promise<ISalesPersonInfo> => {
    const axiosSailTag = createApiClient();
    const response = await axiosSailTag.get<ISalesPersonInfo>(
        `/api/SailInfo/GetSailInfoSalesPerson/${encodeURIComponent(guid)}`,
    );
    return response.data;
};

export const useGetSailInfoSalesPerson = (guid: string) =>
    useQuery<ISalesPersonInfo>({
        queryKey: [
            "GetSailInfoSalesPerson",
            {
                guid: guid ?? null,
            },
        ],
        queryFn: () => {
            if (!guid?.trim()) {
                throw new Error("Invalid params for GetSailInfoSalesPerson");
            }
            return getSailInfoSalesPerson(guid);
        },
        enabled: Boolean(guid?.trim()),
        refetchOnWindowFocus: true,
        retry: false,
    });
